import React from "react";
import { useModalRequestCancelHook } from "./modal-request-cancel-hooks";

type ContextModalRequestCancel = ReturnType<typeof useModalRequestCancelHook>;
export const ModalRequestCancelContext =
  React.createContext<ContextModalRequestCancel | null>(null);

export function useContextModalRequestCancel() {
  const context = React.useContext(ModalRequestCancelContext);

  if (!context) {
    throw new Error(
      "useContextModalRequestCancel must be used within a ContextModalRequestCancelProvider",
    );
  }

  return context;
}
